export default "__VITE_ASSET__615f805d__"